var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { PatientInvoiceSettlement } from '../enums/patient-invoice-settlement.enum.js';
import { PatientInvoiceStatus } from '../enums/patient-invoice-status.enum.js';
export class PatientInvoiceListItemDto {
    id;
    /** Lifecycle only (ADR-0043). */
    status;
    settlement;
    /** Offener Betrag in cents. */
    openAmountCents;
    /** Versendet. */
    sentAt;
    identity;
    documentId;
    issuedAt;
    dueDate;
    createdAt;
    totalGross;
    currency;
    lineCount;
    treatmentPlanIds;
    /**
     * Mahnsperre (per-invoice dunning block, PRD #988). `dunningBlockReason` is
     * non-null while a block is set; `dunningBlockedUntil` is `null` for an
     * indefinite block or a date for a temporary one. Drives the "Mahnsperre"
     * badge in the patient-file "Rechnungen" list (clock-evaluated on the FE).
     */
    dunningBlockReason;
    dunningBlockedUntil;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceListItemDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceListItemDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceListItemDto.prototype, "settlement", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceListItemDto.prototype, "openAmountCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "sentAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "identity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "issuedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "dueDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceListItemDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceListItemDto.prototype, "totalGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceListItemDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceListItemDto.prototype, "lineCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], PatientInvoiceListItemDto.prototype, "treatmentPlanIds", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "dunningBlockReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceListItemDto.prototype, "dunningBlockedUntil", void 0);
//# sourceMappingURL=patient-invoice-list-item.response.dto.js.map